import React, { FC } from 'react'
import Form, { FormComponentProps } from 'antd/lib/form'
import { FormNames } from 'Constants/FormNames'
import { FieldNames } from 'Constants/FieldNames'
import { QuotesInput } from 'Pages/registratorCabinet'

const TestComponent: FC<FormComponentProps> = ({ form }) => {
	return (
		<div>
			<div>
				<QuotesInput
					form={form}
					fieldName={FieldNames.ORG_NAME}
					label="Инпут с кавычками"
					type="text"
					initialValue={undefined}
					required
				/>
			</div>
		</div>
	)
}

export const Test = Form.create<FormComponentProps>({
	name: FormNames.ADVERTISMENT.UNLOAD_REPORT,
})(TestComponent)
